import React from 'react'

const Loader=()=>(
	<div className="modal fade" id="loading" >
		<div className="modal-dialog" role="document">
			<div className="modal-content">
				<div className="modal-header">
					<h4 className="modal-title">Operation in progress...</h4>
				</div>
				<div className="modal-body">
					<div className="center-block d-flex justify-content-center align-items-center">
						<div className="spinner-border text-primary" role="status">
							<span className="sr-only">Loading...</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
)

export default Loader